// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"832190de7329f58cae4e","655":"aba6f55a887aaaffd6a7"}[chunkId] + ".js";
};